<div id="hunt-package-details-page-wrapper">
  <div class="page-header">
    <div class="left">
      <hyperkit-breadcrumb-list
        class="breadcrumb-list"
        [items]="breadcrumbs()"
      ></hyperkit-breadcrumb-list>
      <hyperkit-typography variant="h2">
        {{ activeHuntPackage().title }}
      </hyperkit-typography>

      <div class="meta-data-tags">
        <hyperkit-badge
          [variant]="hunt.queryPackages.severityVariant()"
          [size]="'base'"
          [indicator]="'none'"
          [icon]="'check'"
          [text]="hunt.queryPackages.severity()"
        >
        </hyperkit-badge>

        <hyperkit-tag
          [mode]="'outline'"
          [closable]="false"
          [textLeft]="'Created'"
          [text]="hunt.queryPackages.createdDate() | date: 'mediumDate'"
        ></hyperkit-tag>

        <hyperkit-tag
          [mode]="'outline'"
          [closable]="false"
          [textLeft]="'Author'"
          [text]="hunt.queryPackages.author()"
        ></hyperkit-tag>
      </div>
    </div>

    <div class="right">
      <hyperkit-button
        variant="standard"
        color="secondary"
        size="medium"
        text="Back to Hunt"
        routerLink="/hunt-redesign/{{ hunt.state.hunt().id }}/workbench/"
        icon="arrow-left"
        iconPosition="left"
      ></hyperkit-button>
      <hyperkit-button
        variant="standard"
        color="secondary"
        size="medium"
        text="Done"
        routerLink="/hunt-redesign/{{ hunt.state.hunt().id }}/workbench/"
      ></hyperkit-button>
    </div>
  </div>

  <div class="page-content">
    <div id="hunt-packages">
      <div id="hunt-packages-header">
        <div id="hunt-package-title">
          <hyperkit-typography variant="h5"
            >Package Details</hyperkit-typography
          >
        </div>

        <div id="hunt-package-environment">
          <hyperkit-typography variant="button2"
            >Environment</hyperkit-typography
          >
          <div class="dropdown" id="environment-dropdown">
            <hyperkit-select
              [options]="environments()"
              [valueProperty]="'id'"
              [displayProperty]="'name'"
              [placeholder]="'Select Environment'"
              [state]="'active'"
              [disabled]="false"
              [label]="'Environment'"
              [showLabel]="false"
              [ngModel]="selectedEnvironment()?.id"
              (ngModelChange)="onSelectEnvironmentById($event)"
            >
            </hyperkit-select>
          </div>
        </div>

        <div id="hunt-package-list">
          <div id="hunt-query-header">
            <hyperkit-typography variant="button2"
              >Hunt Queries</hyperkit-typography
            >
          </div>

          <ng-container *ngIf="activeTools()?.length > 0; else noTools">
            <ng-container
              *ngFor="let tool of activeTools(); trackBy: trackByTool"
            >
              <hunt-query-card
                [tool]="tool"
                [selectedQueryId]="hunt.ui.selectedQueryId()"
                [isHuntComplete]="isHuntComplete()"
                (queryClick)="onQuerySelect($event)"
              ></hunt-query-card>
            </ng-container>
          </ng-container>

          <ng-template #noTools>
            <div class="empty-state">
              No tools available for this environment.
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div id="hunt-package-details">
      <!-- Toggle between Default View and Query Selected View -->
      <package-details-default-view
        *ngIf="hunt.ui.isDefaultView()"
      ></package-details-default-view>
      <package-details-query-selected-view
        *ngIf="hunt.ui.isQueryView()"
        [queryInstanceKey]="hunt.ui.selectedQueryId()"

      ></package-details-query-selected-view>
    </div>

    <div id="hunt-notes">
      <hunt-details-editor title="NOTES">
        {{ hunt.editor.hunt()?.notes }}
      </hunt-details-editor>
    </div>
  </div>
</div>
